<div class="signals-screen-header">
  <div class="header-content">
    <div class="top-content">
      <div class="by-polaris-label">Generated Daily by POLARIS™</div>
      <div class="signals-title">Signals</div>
    </div>

    <div class="bottom-content">
      <div class="signals-description">AI-powered recommendations based on your brand and competitor data.</div>
      <div class="signals-date">{{ currentDate | date: 'EEEE, MMMM d, y' }}</div>
    </div>
  </div>
</div>
<div class="signals-main-container">
  <app-signals-welcome-pop></app-signals-welcome-pop>
  <div class="trigger-wrapper">
    <div class="manage-brands-trigger" (click)="openBrandSelectionModal()">
      <img [src]="'svg/settings-wheel.svg' | assetVersion">
      <span>Manage Displayed Brands</span>
    </div>
  </div>
  <div *ngIf="loadingState; else signalsContent">
    <div class="loader"></div>
  </div>
</div>
<ng-template #emptyState>
  <div class="empty-state-container">
    <div class="empty-state-card">
      <div class="empty-state-title">No signals were generated for your brands today.</div>
      <div class="empty-state-description">Signals appear only when our analysis detects something worth highlighting.</div>
    </div>
  </div>
</ng-template>
<ng-template #emptyStateTrial>
  <div class="empty-state-container">
    <div class="empty-state-card generating-signals-card" *ngIf="isTrialUser; else emptyState">
      <div class="loader"></div>
      <div class="empty-state-title">
        Generating your Signals
      </div>  
      <div class="empty-state-description">
        We’re generating your Signals. This may take a few minutes — please refresh or revisit this page shortly.
      </div>
    </div>
  </div>
</ng-template>
<ng-template #signalsContent>
  <div class="signals-cards-wrapper" *ngIf="listOfSignalsData?.signals?.length;else emptyStateTrial">
    @for (signal of listOfSignalsData?.signals; track signal.id) {
      <app-signal-card [signalData]="signal"></app-signal-card>
    }
  </div>
</ng-template>
